import { controlUiPublicAssetPath } from "./public-assets.ts";

export const KANGQIAO_ASSISTANT_NAME = "康桥集团AI助理";
export const KANGQIAO_ASSISTANT_AVATAR_ASSET = "kangqiao/group-logo-mark.png";
export const KANGQIAO_ASSISTANT_AVATAR_PATH = `/${KANGQIAO_ASSISTANT_AVATAR_ASSET}`;

const OPENCLAW_DEFAULT_NAMES = new Set(["", "Assistant", "OpenClaw", "agent"]);
const OPENCLAW_DEFAULT_AVATARS = new Set(["", "A"]);

export function resolveKangqiaoAssistantName(value: string | null | undefined): string {
  const name = value?.trim() ?? "";
  return OPENCLAW_DEFAULT_NAMES.has(name) ? KANGQIAO_ASSISTANT_NAME : name;
}

export function resolveKangqiaoAssistantAvatar(
  value: string | null | undefined,
  basePath: string | null | undefined,
): string {
  const avatar = value?.trim() ?? "";
  if (
    OPENCLAW_DEFAULT_AVATARS.has(avatar) ||
    avatar.endsWith("/apple-touch-icon.png") ||
    avatar.endsWith("/favicon-32.png")
  ) {
    return controlUiPublicAssetPath(KANGQIAO_ASSISTANT_AVATAR_ASSET, basePath);
  }
  return avatar;
}
